<template>
  <div class="cloud-enterprise-auth">
    <div class="title">完成云企业认证，尽享更多价值赋能</div>
    <div class="primary-plain-btn" @click="setCloudRegisterPopup(true)">立即前往</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['setCloudRegisterPopup']),
  }
};
</script>

<style lang="less" scoped>
.cloud-enterprise-auth {
  height: 240px;
  background-image: url('@/assets/img/cooperation/CloudEnterpriseAuth/background.png');
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    font-family: @font-bold;
    font-size: 28px;
    color: #fff;
  }
  .primary-plain-btn {
    width: 185px;
    height: 49px;
    margin-top: 34px;
  }
}
</style>
